import React, { useEffect } from "react";
import styles from "./Loader.module.scss";
import { useSelector } from "react-redux";
// import logo from "../../../assets/images/logo.svg";
const logo = "/logo_dark.png";
const lightLogo = "/logo_light.png";
const Loader = () => {
    const { loading } = useSelector((state) => state.loading);
    const theme = useSelector((state) => state.persist.theme);
    useEffect(() => {
        document.body.style.overflow = loading ? "hidden" : "visible";
    }, [loading]);
    if (loading) {
        return (
            <>
                <span className={styles.loader}>
                    <img src={theme === "light" ? lightLogo : logo} alt="logo" />
                </span>
            </>
        );
    } else {
        return null;
    }
};

export default Loader;
